function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import regeneratorRuntime from "/vercel/path0/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
function PriceBNB(param) {
    var value = param.value;
    var ref = useState(null), price = ref[0], setPrice = ref[1];
    var ref1 = useState(true), loading = ref1[0], setLoading = ref1[1];
    var ref2 = useState(null), error = ref2[0], setError = ref2[1];
    var fetchPriceFromBinanceUS = function() {
        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            var response, data;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return fetch("https://api.binance.us/api/v3/ticker/price?symbol=BNBUSDT", {
                            method: "GET",
                            headers: {
                                "Accept": "application/json"
                            }
                        });
                    case 3:
                        response = _ctx.sent;
                        if (response.ok) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Binance US API failed: ".concat(response.status));
                    case 6:
                        _ctx.next = 8;
                        return response.json();
                    case 8:
                        data = _ctx.sent;
                        return _ctx.abrupt("return", Number(data.price));
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        console.warn("Binance US API failed:", _ctx.t0.message);
                        throw _ctx.t0;
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function fetchPriceFromBinanceUS() {
            return _ref.apply(this, arguments);
        };
    }();
    var fetchPriceFromBinanceGlobal = function() {
        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            var response, data;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return fetch("https://api.binance.com/api/v3/ticker/price?symbol=BNBUSDT", {
                            method: "GET",
                            headers: {
                                "Accept": "application/json"
                            }
                        });
                    case 3:
                        response = _ctx.sent;
                        if (response.ok) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Binance Global API failed: ".concat(response.status));
                    case 6:
                        _ctx.next = 8;
                        return response.json();
                    case 8:
                        data = _ctx.sent;
                        return _ctx.abrupt("return", Number(data.price));
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        console.warn("Binance Global API failed:", _ctx.t0.message);
                        throw _ctx.t0;
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function fetchPriceFromBinanceGlobal() {
            return _ref.apply(this, arguments);
        };
    }();
    var fetchPriceFromCoinGecko = function() {
        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            var response, data;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return fetch("https://api.coingecko.com/api/v3/simple/price?ids=binancecoin&vs_currencies=usd", {
                            method: "GET",
                            headers: {
                                "Accept": "application/json"
                            }
                        });
                    case 3:
                        response = _ctx.sent;
                        if (response.ok) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("CoinGecko API failed: ".concat(response.status));
                    case 6:
                        _ctx.next = 8;
                        return response.json();
                    case 8:
                        data = _ctx.sent;
                        return _ctx.abrupt("return", Number(data.binancecoin.usd));
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        console.warn("CoinGecko API failed:", _ctx.t0.message);
                        throw _ctx.t0;
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function fetchPriceFromCoinGecko() {
            return _ref.apply(this, arguments);
        };
    }();
    var detectRegionAndFetchPrice = function() {
        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            var isUSRegion, timezone, apis, i, fetchedPrice;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(price !== null)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        setLoading(true);
                        setError(null);
                        isUSRegion = false;
                        try {
                            timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                            isUSRegion = timezone.includes("America/") && (timezone.includes("New_York") || timezone.includes("Chicago") || timezone.includes("Denver") || timezone.includes("Los_Angeles"));
                        } catch (e) {
                            console.warn("Could not detect timezone:", e);
                        }
                        apis = isUSRegion ? [
                            fetchPriceFromBinanceUS,
                            fetchPriceFromBinanceGlobal,
                            fetchPriceFromCoinGecko
                        ] : [
                            fetchPriceFromBinanceGlobal,
                            fetchPriceFromBinanceUS,
                            fetchPriceFromCoinGecko
                        ];
                        i = 0;
                    case 8:
                        if (!(i < apis.length)) {
                            _ctx.next = 27;
                            break;
                        }
                        _ctx.prev = 9;
                        console.log("Attempting to fetch BNB price from API ".concat(i + 1, "..."));
                        _ctx.next = 13;
                        return apis[i]();
                    case 13:
                        fetchedPrice = _ctx.sent;
                        if (!(fetchedPrice && !isNaN(fetchedPrice) && fetchedPrice > 0)) {
                            _ctx.next = 19;
                            break;
                        }
                        setPrice(fetchedPrice);
                        setLoading(false);
                        console.log("Successfully fetched BNB price: $".concat(fetchedPrice));
                        return _ctx.abrupt("return");
                    case 19:
                        _ctx.next = 24;
                        break;
                    case 21:
                        _ctx.prev = 21;
                        _ctx.t0 = _ctx["catch"](9);
                        console.warn("API ".concat(i + 1, " failed:"), _ctx.t0.message);
                    case 24:
                        i++;
                        _ctx.next = 8;
                        break;
                    case 27:
                        // Si todas las APIs fallan, establecer un precio por defecto
                        console.error("All APIs failed, using fallback price");
                        setPrice(650); // Precio de fallback aproximado
                        setError("Unable to fetch live price, showing approximate value");
                        setLoading(false);
                    case 31:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    9,
                    21
                ]
            ]);
        }));
        return function detectRegionAndFetchPrice() {
            return _ref.apply(this, arguments);
        };
    }();
    useEffect(function() {
        detectRegionAndFetchPrice();
    }, []);
    if (loading) {
        return /*#__PURE__*/ _jsx("span", {
            children: "---.--"
        });
    }
    if (error) {
        console.warn("Price fetch error:", error);
    }
    return value ? /*#__PURE__*/ _jsx("span", {
        children: price ? (price * value).toFixed(2) : "---"
    }) : /*#__PURE__*/ _jsx("span", {
        children: price ? price.toFixed(2) : "---"
    });
}
export function UsePriceBNB() {
    var ref = useState(null), price = ref[0], setPrice = ref[1];
    var ref3 = useState(0), currentPrice = ref3[0], setCurrentPrice = ref3[1];
    var ref4 = useState(0), value = ref4[0], setValue = ref4[1];
    var ref5 = useState(true), loading = ref5[0], setLoading = ref5[1];
    var ref6 = useState(null), error = ref6[0], setError = ref6[1];
    var fetchPriceFromBinanceUS = function() {
        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            var response, data;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return fetch("https://api.binance.us/api/v3/ticker/price?symbol=BNBUSDT", {
                            method: "GET",
                            headers: {
                                "Accept": "application/json"
                            }
                        });
                    case 3:
                        response = _ctx.sent;
                        if (response.ok) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Binance US API failed: ".concat(response.status));
                    case 6:
                        _ctx.next = 8;
                        return response.json();
                    case 8:
                        data = _ctx.sent;
                        return _ctx.abrupt("return", Number(data.price));
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        console.warn("Binance US API failed:", _ctx.t0.message);
                        throw _ctx.t0;
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function fetchPriceFromBinanceUS() {
            return _ref.apply(this, arguments);
        };
    }();
    var fetchPriceFromBinanceGlobal = function() {
        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            var response, data;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return fetch("https://api.binance.com/api/v3/ticker/price?symbol=BNBUSDT", {
                            method: "GET",
                            headers: {
                                "Accept": "application/json"
                            }
                        });
                    case 3:
                        response = _ctx.sent;
                        if (response.ok) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Binance Global API failed: ".concat(response.status));
                    case 6:
                        _ctx.next = 8;
                        return response.json();
                    case 8:
                        data = _ctx.sent;
                        return _ctx.abrupt("return", Number(data.price));
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        console.warn("Binance Global API failed:", _ctx.t0.message);
                        throw _ctx.t0;
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function fetchPriceFromBinanceGlobal() {
            return _ref.apply(this, arguments);
        };
    }();
    var fetchPriceFromCoinGecko = function() {
        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            var response, data;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return fetch("https://api.coingecko.com/api/v3/simple/price?ids=binancecoin&vs_currencies=usd", {
                            method: "GET",
                            headers: {
                                "Accept": "application/json"
                            }
                        });
                    case 3:
                        response = _ctx.sent;
                        if (response.ok) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("CoinGecko API failed: ".concat(response.status));
                    case 6:
                        _ctx.next = 8;
                        return response.json();
                    case 8:
                        data = _ctx.sent;
                        return _ctx.abrupt("return", Number(data.binancecoin.usd));
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        console.warn("CoinGecko API failed:", _ctx.t0.message);
                        throw _ctx.t0;
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function fetchPriceFromCoinGecko() {
            return _ref.apply(this, arguments);
        };
    }();
    var detectRegionAndFetchPrice = function() {
        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            var isUSRegion, timezone, apis, i, fetchedPrice;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(price !== null)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        setLoading(true);
                        setError(null);
                        isUSRegion = false;
                        try {
                            timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                            isUSRegion = timezone.includes("America/") && (timezone.includes("New_York") || timezone.includes("Chicago") || timezone.includes("Denver") || timezone.includes("Los_Angeles"));
                        } catch (e) {
                            console.warn("Could not detect timezone:", e);
                        }
                        apis = isUSRegion ? [
                            fetchPriceFromBinanceUS,
                            fetchPriceFromBinanceGlobal,
                            fetchPriceFromCoinGecko
                        ] : [
                            fetchPriceFromBinanceGlobal,
                            fetchPriceFromBinanceUS,
                            fetchPriceFromCoinGecko
                        ];
                        i = 0;
                    case 8:
                        if (!(i < apis.length)) {
                            _ctx.next = 27;
                            break;
                        }
                        _ctx.prev = 9;
                        console.log("Hook: Attempting to fetch BNB price from API ".concat(i + 1, "..."));
                        _ctx.next = 13;
                        return apis[i]();
                    case 13:
                        fetchedPrice = _ctx.sent;
                        if (!(fetchedPrice && !isNaN(fetchedPrice) && fetchedPrice > 0)) {
                            _ctx.next = 19;
                            break;
                        }
                        setPrice(fetchedPrice);
                        setLoading(false);
                        console.log("Hook: Successfully fetched BNB price: $".concat(fetchedPrice));
                        return _ctx.abrupt("return");
                    case 19:
                        _ctx.next = 24;
                        break;
                    case 21:
                        _ctx.prev = 21;
                        _ctx.t0 = _ctx["catch"](9);
                        console.warn("Hook: API ".concat(i + 1, " failed:"), _ctx.t0.message);
                    case 24:
                        i++;
                        _ctx.next = 8;
                        break;
                    case 27:
                        // Fallback
                        console.error("Hook: All APIs failed, using fallback price");
                        setPrice(650);
                        setError("Unable to fetch live price, showing approximate value");
                        setLoading(false);
                    case 31:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    9,
                    21
                ]
            ]);
        }));
        return function detectRegionAndFetchPrice() {
            return _ref.apply(this, arguments);
        };
    }();
    useEffect(function() {
        if (price && !isNaN(price) && !isNaN(value)) {
            setCurrentPrice((Number(price) * Number(value)).toFixed(2));
        } else {
            setCurrentPrice(0);
        }
    }, [
        value,
        price
    ]);
    useEffect(function() {
        detectRegionAndFetchPrice();
    }, []);
    return [
        currentPrice,
        price,
        setValue,
        loading,
        error
    ];
}
export default PriceBNB;
